export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-archive-6c0c22d03bca752bc342b261a39c0669.svg";